import _ from 'lodash';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../../themed/button';
import Form from '../../../common/form';

import { Column } from '../../../../utils/models';

class PECReadingEditForm extends Form {
	state = {
		data: {},
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		columns: PropTypes.array,
		readingToEdit: PropTypes.object,
		onEdit: PropTypes.func,
		onCancelEdit: PropTypes.func,
	};


	mapData = () => {
		const columns: Column[] = this.props.columns
		const data: any = {};
		const schema: any = {};

		for (const column of columns) {
			if (column.path === 'srNo') {
				schema[column.path] = Joi.number().required().label(column.path);
			} else {
				schema[column.path] = Joi.alternatives().try(Joi.number().min(0), Joi.string().valid('N/A', 'R/A')).required().label(column.path);
			}
			
			data[column.path] = _.get(this.props.readingToEdit, column.path) ?? '';
		}

		this.schema = schema;
		this.setState({ data });
	};

	componentDidMount(): void {
		this.mapData();
	}

	doSubmit = (): void => {
		this.props.onEdit(this.state.data);
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<h2 className="form-title">Scan Data Readings</h2>

				<div className="row">
					{Object.keys(this.state.data).map((key) => (
						<div key={key} className="col">
							{this.renderInput({
								type: 'number',
								name: key,
								placeholder: 'Enter ' + key,
								label: key,
							})}
						</div>
					))}
				</div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Update Scan Details')}
						
					<div className="mx-4">
						<Button label='Cancel' style={{ backgroundColor: 'red' }} onClick={this.props.onCancelEdit} />
					</div>
				</div>
			</form>
		);
	}
}

export default PECReadingEditForm;
